import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Play } from "lucide-react";

const IMAGES = [
  "https://images.unsplash.com/photo-1505843795480-5cfb3c03f6ff",
  "https://images.unsplash.com/photo-1599409637219-d04e9a2db432",
  "https://images.unsplash.com/photo-1635111057505-3b7dcc2b72fb",
  "https://images.unsplash.com/photo-1500382017468-9049fed747ef",
  "https://images.unsplash.com/photo-1518005020951-eccb494ad742",
  "https://images.unsplash.com/photo-1449844908441-8829872d2607",
];

const CATS = ["Images", "Drone", "Customer Photos", "Registration", "Development Progress"];

export default function Gallery() {
  const [cat, setCat] = useState("Images");
  return (
    <div className="font-body">
      <div className="bg-[#08341f] py-16 text-center text-white">
        <p className="text-sm uppercase tracking-[0.25em] text-[#D4AF37] font-semibold">Gallery</p>
        <h1 className="font-heading text-4xl lg:text-5xl font-bold mt-3">Moments & Milestones</h1>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14">
        <div className="flex flex-wrap gap-2 justify-center mb-10">
          {CATS.map((c) => (
            <button key={c} data-testid={`gallery-cat-${c.toLowerCase().replace(/ /g,'-')}`} onClick={()=>setCat(c)} className={`rounded-full px-5 py-2 text-sm font-medium transition-colors ${cat===c?"bg-[#0B5D3B] text-white":"bg-gray-100 text-gray-700 hover:bg-gray-200"}`}>{c}</button>
          ))}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {IMAGES.map((img,i)=>(
            <div key={i} className="relative rounded-xl overflow-hidden group h-56 md:h-72">
              <img src={img} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
              {cat==="Drone" && <span className="absolute inset-0 grid place-items-center bg-black/30"><Play className="text-white" size={40}/></span>}
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 pb-8">
        <h2 className="font-heading text-3xl font-bold text-gray-900 text-center mb-10">Video Gallery</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[0,1].map((i)=>(
            <div key={i} className="aspect-video rounded-xl overflow-hidden border border-gray-100">
              <iframe src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="video" className="w-full h-full" allowFullScreen/>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
